import * as api from '../api/pricingTable';
import {
  createRequestTypes,
  START,
  SUCCESS,
  ERROR,
} from '@modules/appraisal/actions/global';
import { makeApiActionCreatorV3 } from '@actions/utils';

export const FETCH_ALL_YEARS = createRequestTypes(
  'PRICING_TABLE/FETCH_ALL_YEARS',
);

export const FETCH_PRICING_SCHEDULES = createRequestTypes(
  'PRICING_TABLE/FETCH_PRICING_SCHEDULES',
);

export const FETCH_PRICING_SCHEDULE = createRequestTypes(
  'PRICING_TABLE/FETCH_PRICING_SCHEDULE',
);

export const INSERT_PRICING_SCHEDULE = createRequestTypes(
  'PRICING_TABLE/INSERT_PRICING_SCHEDULE',
);

export const UPDATE_PRICING_SCHEDULE = createRequestTypes(
  'PRICING_TABLE/UPDATE_PRICING_SCHEDULE',
);

export const DELETE_PRICING_SCHEDULE = createRequestTypes(
  'PRICING_TABLE/DELETE_PRICING_SCHEDULE',
);

export const DUPLICATE_PRICING_SCHEDULE = createRequestTypes(
  'PRICING_TABLE/DUPLICATE_PRICING_SCHEDULE',
);

export const FETCH_PRICING_SCHEDULES_CONFIG = createRequestTypes(
  'PRICING_TABLE/FETCH_PRICING_SCHEDULES_CONFIG',
);

export const FETCH_PRICING_SCHEDULES_AXIS_VALUES = createRequestTypes(
  'PRICING_TABLE/FETCH_PRICING_SCHEDULES_AXIS_VALUES',
);

export const INITIALIZE_PRICING_SCHEDULE = createRequestTypes(
  'PRICING_TABLE/INITIALIZE_PRICING_SCHEDULE',
);

export const UPDATE_PRICING_SCHEDULE_DETAIL = createRequestTypes(
  'PRICING_TABLE/UPDATE_PRICING_SCHEDULE_DETAIL',
);

export const FETCH_ALL_PRICING_SCHEDULE_DETAILS = createRequestTypes(
  'PRICING_TABLE/FETCH_ALL_PRICING_SCHEDULE_DETAILS',
);

export const IMPORT_PRICING_SCHEDULE_AXIS_VALUES = createRequestTypes(
  'PRICING_TABLE/IMPORT_PRICING_SCHEDULE_AXIS_VALUES',
);

export const FETCH_PRICING_SCHEDULE_AXIS_VALUES = createRequestTypes(
  'PRICING_TABLE/FETCH_PRICING_SCHEDULE_AXIS_VALUES',
);

export const INSERT_PRICING_SCHEDULE_AXIS_VALUE = createRequestTypes(
  'PRICING_TABLE/INSERT_PRICING_SCHEDULE_AXIS_VALUE',
);

export const DELETE_PRICING_SCHEDULE_AXIS_VALUE = createRequestTypes(
  'PRICING_TABLE/DELETE_PRICING_SCHEDULE_AXIS_VALUE',
);

export const FETCH_PRICING_SCHEDULE_DETAIL = createRequestTypes(
  'PRICING_TABLE/FETCH_PRICING_SCHEDULE_DETAIL',
);

export const fetchAllYears = makeApiActionCreatorV3(
  api.fetchAllYears,
  FETCH_ALL_YEARS[START],
  FETCH_ALL_YEARS[SUCCESS],
  FETCH_ALL_YEARS[ERROR],
);

export const fetchPricingSchedules = makeApiActionCreatorV3(
  api.fetchPricingSchedules,
  FETCH_PRICING_SCHEDULES[START],
  FETCH_PRICING_SCHEDULES[SUCCESS],
  FETCH_PRICING_SCHEDULES[ERROR],
);

export const fetchPricingSchedule = makeApiActionCreatorV3(
  api.fetchPricingSchedule,
  FETCH_PRICING_SCHEDULE[START],
  FETCH_PRICING_SCHEDULE[SUCCESS],
  FETCH_PRICING_SCHEDULE[ERROR],
);

export const deletePricingSchedule = makeApiActionCreatorV3(
  api.deletePricingSchedule,
  DELETE_PRICING_SCHEDULE[START],
  DELETE_PRICING_SCHEDULE[SUCCESS],
  DELETE_PRICING_SCHEDULE[ERROR],
);

export const insertPricingSchedule = makeApiActionCreatorV3(
  api.insertPricingSchedule,
  INSERT_PRICING_SCHEDULE[START],
  INSERT_PRICING_SCHEDULE[SUCCESS],
  INSERT_PRICING_SCHEDULE[ERROR],
);

export const updatePricingSchedule = makeApiActionCreatorV3(
  api.updatePricingSchedule,
  UPDATE_PRICING_SCHEDULE[START],
  UPDATE_PRICING_SCHEDULE[SUCCESS],
  UPDATE_PRICING_SCHEDULE[ERROR],
);

export const duplicatePricingSchedule = makeApiActionCreatorV3(
  api.duplicatePricingSchedule,
  DUPLICATE_PRICING_SCHEDULE[START],
  DUPLICATE_PRICING_SCHEDULE[SUCCESS],
  DUPLICATE_PRICING_SCHEDULE[ERROR],
);

export const fetchPricingSchedulesConfig = makeApiActionCreatorV3(
  api.fetchPricingSchedulesConfig,
  FETCH_PRICING_SCHEDULES_CONFIG[START],
  FETCH_PRICING_SCHEDULES_CONFIG[SUCCESS],
  FETCH_PRICING_SCHEDULES_CONFIG[ERROR],
);

export const fetchPricingSchedulesAxisValues = makeApiActionCreatorV3(
  api.fetchPricingSchedulesAxisValues,
  FETCH_PRICING_SCHEDULES_AXIS_VALUES[START],
  FETCH_PRICING_SCHEDULES_AXIS_VALUES[SUCCESS],
  FETCH_PRICING_SCHEDULES_AXIS_VALUES[ERROR],
);

export const initializePricingSchedule = makeApiActionCreatorV3(
  api.initializePricingSchedule,
  INITIALIZE_PRICING_SCHEDULE[START],
  INITIALIZE_PRICING_SCHEDULE[SUCCESS],
  INITIALIZE_PRICING_SCHEDULE[ERROR],
);

export const fetchAllPricingTableScheduleDetails = makeApiActionCreatorV3(
  api.fetchAllPricingScheduleDetails,
  FETCH_ALL_PRICING_SCHEDULE_DETAILS[START],
  FETCH_ALL_PRICING_SCHEDULE_DETAILS[SUCCESS],
  FETCH_ALL_PRICING_SCHEDULE_DETAILS[ERROR],
);

export const updatePricingScheduleDetail = makeApiActionCreatorV3(
  api.updatePricingScheduleDetail,
  UPDATE_PRICING_SCHEDULE_DETAIL[START],
  UPDATE_PRICING_SCHEDULE_DETAIL[SUCCESS],
  UPDATE_PRICING_SCHEDULE_DETAIL[ERROR],
);

export const importPricingScheduleAxisValues = makeApiActionCreatorV3(
  api.importPricingScheduleAxisValues,
  IMPORT_PRICING_SCHEDULE_AXIS_VALUES[START],
  IMPORT_PRICING_SCHEDULE_AXIS_VALUES[SUCCESS],
  IMPORT_PRICING_SCHEDULE_AXIS_VALUES[ERROR],
);

export const fetchPricingScheduleAxisValues = makeApiActionCreatorV3(
  api.fetchPricingScheduleAxisValues,
  FETCH_PRICING_SCHEDULE_AXIS_VALUES[START],
  FETCH_PRICING_SCHEDULE_AXIS_VALUES[SUCCESS],
  FETCH_PRICING_SCHEDULE_AXIS_VALUES[ERROR],
);

export const insertPricingScheduleAxisValue = makeApiActionCreatorV3(
  api.insertPricingScheduleAxisValue,
  INSERT_PRICING_SCHEDULE_AXIS_VALUE[START],
  INSERT_PRICING_SCHEDULE_AXIS_VALUE[SUCCESS],
  INSERT_PRICING_SCHEDULE_AXIS_VALUE[ERROR],
);

export const deletePricingScheduleAxisValue = makeApiActionCreatorV3(
  api.deletePricingScheduleAxisValue,
  DELETE_PRICING_SCHEDULE_AXIS_VALUE[START],
  DELETE_PRICING_SCHEDULE_AXIS_VALUE[SUCCESS],
  DELETE_PRICING_SCHEDULE_AXIS_VALUE[ERROR],
);
